import type {Theme} from '../theme';
import {createBaseThemeVariation} from './base';

export const BBOdysseyTheme: Theme = createBaseThemeVariation({
    name: 'bbodyssey',
    brandColor: 'hsla(319, 100%, 18%, 1)',
});
